import {AlunoPremiado} from "@/models/AlunoPremiado";

export default {
  nivel1: {
    ouro: [
      new AlunoPremiado('Artur Rebouças de Alencar Araripe', 'A'),
      new AlunoPremiado('Francisco Abner Gomes da Silva', 'A'),
      new AlunoPremiado('Luiz Efraim Cavalcante Basílio', 'A', 1),
      new AlunoPremiado('Manuela Vasconcelos Magalhaes Gurgel', 'A')
    ],
    prata: [
      new AlunoPremiado('Daniel Leite Mendes', 'A', 2),
      new AlunoPremiado('Davi Lima Maia'),
      new AlunoPremiado('Giovanna Pereira Ramos'),
      new AlunoPremiado('Leonardo Paiva Lima')
    ],
    bronze: [
      new AlunoPremiado('Gabriel de Castro Loiola'),
      new AlunoPremiado('Letícia Frota Barreto'),
      new AlunoPremiado('Lucas dos Santos Mauricio Maia'),
      new AlunoPremiado('Matheus Silva de Arruda'),
      new AlunoPremiado('Miguel Jesus Francisco Nogueira'),
      new AlunoPremiado('Samuel Caleb Nunes Camara')
    ],
    mencaoHonrosa: [
      new AlunoPremiado('Gabriel Mourão da Silva'),
      new AlunoPremiado('Ian Tomás Martins Moura'),
      new AlunoPremiado('Jose Ricardo de Moraes Costa Neto'),
      new AlunoPremiado('Lucas Oquendo Nogueira Madeira'),
      new AlunoPremiado('Marcelo Machado Silva'),
      new AlunoPremiado('Maria Cecilia Becco de Souza França Pinto'),
      new AlunoPremiado('Maria Gabriela Correia Souza'),
      new AlunoPremiado('Matheus Castro Nobre'),
      new AlunoPremiado('Nicole Alencar Rodrigues'),
      new AlunoPremiado('Pedro de Sa Pereira Pacheco')
    ],
    hasOuroEspecial: () => false
  },
  nivel2: {
    ouro: [
      new AlunoPremiado('Gabriel Amorim Santiago', 1),
      new AlunoPremiado('Josué Busetti', 1),
      new AlunoPremiado('Julia de Paula Pessoa Leguiza', 1)
    ],
    prata: [
      new AlunoPremiado('Arthur Giovani Cavalcante da Ponte'),
      new AlunoPremiado('Enzo Holanda Sampaio'),
      new AlunoPremiado('Laura Oliveira Mota', 1, 2),
      new AlunoPremiado('Raul Saraiva Cavalcante', 1, 1)
    ],
    bronze: [
      new AlunoPremiado('Arthur Alencar Spuri'),
      new AlunoPremiado('Breno Castro Oliveira'),
      new AlunoPremiado('Caio Facó Fonseca Bittencourt'),
      new AlunoPremiado('Gabriel Mota Caminha Muniz'),
      new AlunoPremiado('Levi Freitas Nunes'),
      new AlunoPremiado('Ronaldo Ponte de Aragao Rodrigues'),
      new AlunoPremiado('Samuel Nogueira Santiago'),
      new AlunoPremiado('Sofia Costa Lima Pinheiro'),
      new AlunoPremiado('Valentina Vale Farias Cruz')
    ],
    mencaoHonrosa: [
      new AlunoPremiado('Cassio Cavalcante Colares'),
      new AlunoPremiado('Daniela Emilia Cerda Sales'),
      new AlunoPremiado('Gabriel Mendes Freitas'),
      new AlunoPremiado('Maria Emília do Prado Cardoso'),
      new AlunoPremiado('Mell Rodrigues Gerage'),
      new AlunoPremiado('Pedro Silva do Nascimento'),
      new AlunoPremiado('Philippe Cernicky'),
      new AlunoPremiado('Tiago Rocha Morais de Santiago'),
      new AlunoPremiado('Vinicius Martins Ribeiro')
    ],
    hasOuroEspecial: () => false
  },
  nivel3: {
    ouro: [
      new AlunoPremiado('Levi Felix Barbosa', 2),
      new AlunoPremiado('Matheus Alencar de Moraes', 2),
    ],
    prata: [
      new AlunoPremiado('Bilhana Plamenova Kochloukova', 3, 2),
      new AlunoPremiado('Caique Paiva', 2),
      new AlunoPremiado('Cecília Mileski de Paula', 3),
      new AlunoPremiado('Isabela Ruthner Dorn', 3),
      new AlunoPremiado('João Gilberti Alves Tavares', 3, 1),
      new AlunoPremiado('Pedro Henrique de Almeida Ursino', 3)
    ],
    bronze: [
      new AlunoPremiado('Andrea Quintanilla Torrez'),
      new AlunoPremiado('Gabriel Seares Dellaroli'),
      new AlunoPremiado('Gustavo Mesquita França'),
      new AlunoPremiado('João Victor Silva dos Santos'),
      new AlunoPremiado('Levi Magalhães Pereira Castello Branco', 2, 2),
      new AlunoPremiado('Miguel Chianca Evangelista'),
      new AlunoPremiado('Pedro Duarte Borges'),
      new AlunoPremiado('Rodrigo Fontenele de Oliveira Linhares', 2, 1)
    ],
    mencaoHonrosa: [
      new AlunoPremiado('Alessandro Mathias Machado'),
      new AlunoPremiado('Darlan Vitor Albuquerque Franca'),
      new AlunoPremiado('Endy Lumy Okamura Miyashita'),
      new AlunoPremiado('Enzo Dantas de Britto M Araujo'),
      new AlunoPremiado('Fabricia Cardoso Marques'),
      new AlunoPremiado('João Paulo Pereira da Silva'),
      new AlunoPremiado('Lucas Oliveira Galindo Almeida'),
      new AlunoPremiado('Paulo Otavio Portela Santana'),
      new AlunoPremiado('Raira Lins Cruz de Moura'),
      new AlunoPremiado('Vinicius Arcanjo Fonseca de Oliveira')
    ],
    hasOuroEspecial: () => false
  },
}
